import { ProductAmountStyled } from './styles'

const ProductAmmount = (props: { quantity: number }) => {
  return (
    <ProductAmountStyled className="product-quantity">
      ({props.quantity})
    </ProductAmountStyled>
  )
}

export default ProductAmmount
